import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import HeaderCurriculum from '../components/header_curriculum/HeaderCurriculum'
import CurriculumInfo from '../components/header_curriculum/CurriculumInfo'
import Footer from '../components/footer/Footer'
import Programs from '../components/programs/Programs'

export default function CurriculumPage() {
  usePageMeta({
    title: 'Preschool Curriculum & Programs | Learning In Motion Academy',
    description: 'Frog Street and Montessori-inspired curriculum for infants, toddlers, preschool and VPK at our Tamarac, FL academy.',
    path: '/curriculum',
  })

  return (
    <>
      <Navbar/>
      <HeaderCurriculum/>
      <CurriculumInfo/>
      <Programs/>
      <Footer/>
    </>
  )
}
